import React from "react";

const Checkbox = ({ name, label, checked, click }) => {
  return (
    <div>
      <label>
        <input
          type="checkbox"
          defaultChecked={checked}
          onClick={(e) => click(name, e.target.checked)}
          name={name}
        />{" "}
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
